export var version = "3.11.8";
//# sourceMappingURL=version.js.map